




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































/*
  修改信息根据id获取到当前得伤情信息数据遍历
*/
import { Vue, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import moment from 'moment'
import Component from 'vue-class-component'
import {
  addtopic,
  gettopicinfo,
  addtopicdata,
  updatetopic,
  updateinfo,
  gettableinfo,
  addmajor,
  getmajorinfo,
  adddesign,
  getdesigninfo,
  addbasics,
  getbasicsinfo,
  addyqyjcg,
  getyqyjcginfo,
  addjfgl,
  getjfglinfo,
  addndktlz,
  getndktlzinfo,
  uploadzsxg,
  addbudget,
  getbudgetinfo,
  addopinion,
  getopinioninfo,
  getcertificateinfo,
  updateuploadfile,
  downloadfile,
  downloadfileapplication,
  downloadjffile,
  downloadPDF,
  getktsjinfo,
  updatetopicfile,
  getguidlist,
  downloadpdf,
  gettpoicinfo,
  removefile
} from '@/api/declare'
import $ from 'jquery'
import '../../../public/ueditor/ueditor.config.js'
import './../../../public/ueditor/ueditor.all.js'
import '../../../public/ueditor/lang/zh-cn/zh-cn.js'
import VueUeditorWrap from 'vue-ueditor-wrap'
import { ElSlider } from 'element-ui/types/slider'
import { monitorEventLoopDelay } from 'perf_hooks'

@Component({
  name: 'equipManage',
  components: { VueUeditorWrap }
})
export default class extends Vue {
  [x: string]: /*
    修改信息根据id获取到当前得伤情信息数据遍历
  */
  any;
  /*
    修改信息根据id获取到当前得伤情信息数据遍历
  */
  created() {
    debugger
    this.citylist = require('./../../../public/city.json')
    this.grouplist = require('./../../../public/group.json')
    let topicinfo = JSON.parse(sessionStorage.getItem('topicinfo') as any)
    if (topicinfo) {
      if (topicinfo.state == 4) {
        this.isshowysagree = true
        this.refuseobj.content = topicinfo.dismiss
        this.refuseobj.fund = topicinfo.fund
      } else if (topicinfo.state == 1) {
        this.isshowagree = true
      } else if (topicinfo.state == 5 || topicinfo.state == 7 || topicinfo.state == 11) {
        this.isshowrefuse = true
        if (topicinfo.isrefuse === '1') {
          this.isShowDismiss = false
        } else {
          this.isShowDismiss = true
        }
        this.refuseobj.content = topicinfo.dismiss
      } else if (topicinfo.state == 13) {
        this.jieduan = true;
        this.jieduanupload = true;
      } else if (topicinfo.state == 14) {
        this.jieti = true;
        this.jietiupload = true;
        this.jietidelete = true;
      }else {
        this.isshowysagree = false
        this.isshowagree = false
      }
    } else {
      this.isshowysagree = false
    }
  }

  // 监听数据表数据变化
  // @Watch("dataForm.administrative", { immediate: true, deep: true })
  @Watch('dataForm', { deep: true })
  changeform1(newVal, oldVal) {
    if (JSON.stringify(this.copetabledata) !== JSON.stringify(newVal)) {
      this.tabsbool[0].isshow = true
    }
  }
  // 监听数据表主要参与者
  @Watch('datatable.data', { deep: true })
  changeformsj(newVal, oldVal) {
    if (JSON.stringify(this.copedatatable) !== JSON.stringify(newVal)) {
      this.tabsbool[0].isshow = true
    }
  }
  // 监听数据表主要参与制
  @Watch('partner.data', { deep: true })
  changeformxz(newVal, oldVal) {
    if (JSON.stringify(this.copepranter) !== JSON.stringify(newVal)) {
      this.tabsbool[0].isshow = true
    }
  }
  // // 监听负责人数据变化
  @Watch('principal.data', { deep: true })
  changeform2(newVal, oldVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copepricdata)) {
      this.tabsbool[1].isshow = true
    }
  }
  // // 监听相关证书数据变化
  @Watch('uploadobj.fileSizeIsSatisfy', { deep: true })
  changeform3(newVal, oldVal) {
    if (JSON.stringify(newVal) != JSON.stringify(this.copefilelist)) {
      this.tabsbool[2].isshow = true
    }
  }
  // 监听课题设计论证数据变化
  @Watch('editor.content', { deep: true })
  changeform4(newVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copeobj)) {
      this.tabsbool[3].isshow = true
    }
  }
  // 监听研究基础数据变化
  @Watch('editor.yjjccontent', { deep: true })
  changeform5(newVal, oldVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copeobj)) {
      this.tabsbool[4].isshow = true
    }
  }
  // // 监听经费预算自主金额
  @Watch('budgetdata', { deep: true })
  changeform6(newVal, oldVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copejfyslist)) {
      this.tabsbool[6].isshow = true
    }
  }
  // 监听经费预算年度经费预算
  @Watch('allyearnum.data', { deep: true })
  changeform7(newVal, oldVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copeallyearlist)) {
      this.tabsbool[6].isshow = true
    }
  }
  // 监听经费预期研究成果
  @Watch('expecteddata.data', { deep: true })
  changeform8(newVal, oldVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copepricdata)) {
      this.tabsbool[5].isshow = true
    }
  }
  // 监听经费管理
  @Watch('jfysForm', { deep: true })
  changeform9(newVal, oldVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copejfgl)) {
      this.tabsbool[7].isshow = true
    }
  }
  // 监听单位意见
  @Watch('editor.dwyjcontent', { deep: true })
  changeform10(newVal, oldVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copeobj)) {
      this.tabsbool[8].isshow = true
    }
  }
  // 监听课题论证活页
  @Watch('editor.ndktcontent', { deep: true })
  changeform13(newVal, oldVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copeobj)) {
      this.tabsbool[9].isshow = true
    }
  }
  // 监听课题论证活页
  @Watch('editor.topicName', { deep: true })
  changeform14(newVal, oldVal) {
    if (JSON.stringify(newVal) !== JSON.stringify(this.copetopicname)) {
      this.tabsbool[9].isshow = true
    }
  }
  // 监听经费管理
  @Watch('iswatch')
  changeform11(newVal, oldVal) {
    console.log(newVal)
    if (newVal == false) {
      $('.iseditys').css({ 'pointer-events': 'none' })
      // 这里监听iswatch 变化后调用this.UEeditorready()方法 禁用ueditor
      if (this.editorlist1 != '') {
        this.UEeditorready1(this.editorlist1)
      } else if (this.editorlist2 != '') {
        this.UEeditorready2(this.editorlist2)
      } else if (this.editorlist3 != '') {
        this.UEeditorready3(this.editorlist3)
      }

      $('.zcbtn').css({ display: 'none' })
      window.sessionStorage.setItem('iswatch', 'true')
    }
  }
  // 监听调整预算附件上传成功后
  @Watch('fziseditys')
  changeform12(newVal, oldVal) {
    if (newVal == false) {
      $('.iseditys').css({ 'pointer-events': 'none' })
      $('.zcbtn').css({ display: 'none' })
      // window.sessionStorage.setItem("iswatch", "true");
    }
  }
  // 监听课题附件数组变化
   @Watch('uploadData')
  changektfjlist(newVal, oldVal) {
    if (newVal.length > 0) {
      this.uploadktfj = true
    } else {
      this.uploadktfj = false
    }
  }
   // 监听课题附件数组变化
   @Watch('ysuploadData')
   changejfyslist(newVal, oldVal) {
     if (newVal.length > 0) {
       this.uploadtzys = true
     } else {
       this.uploadtzys = false
     }
   }

   // 监听阶段汇报数组变化
   @Watch('jduploadData')
   changejdhblist(newVal, oldVal) {
     if (newVal.length > 0) {
       this.uploadjdhb = true
     } else {
       this.uploadjdhb = false
     }
   }

   // 监听结题汇报数组变化  copy14  andy
   @Watch('jtuploadData')
   changezqhblist(newVal, oldVal) {
     if (newVal.length > 0) {
       this.uploadjthb = true
     } else {
       this.uploadjthb = false
     }
   }

   mounted() {
     // this.copetabledata = JSON.parse(JSON.stringify(this.dataForm));
     // 判断topicid.topicId存在是编辑 topicid存在是新增
     // iswatch 查看时候为false  iseditys驳回预算后控制经费预算页和提交课题 预算调整附件上传
     this.getguidelist()
     this.dqyear = JSON.parse(window.sessionStorage.getItem('time') as any)
     let topicparam = window.sessionStorage.getItem('topicid') as any
     let iswatch = window.sessionStorage.getItem('iswatch') as any
     console.log(iswatch)
     let isedit = window.sessionStorage.getItem('iseditys') as any
     let fziseditys = sessionStorage.getItem('fziseditys') as any
     this.baseurl = (window as any).baseurl

     console.log(JSON.parse(topicparam).topicId)

     if (JSON.parse(topicparam).topicId) {
       this.topicid = JSON.parse(topicparam).topicId
       console.log(this.topicid)
       if (this.topicid) {
         this.gettabledatinfo()
         if (iswatch != null) {
           $('.iseditys').css({ 'pointer-events': 'none' })
           // 隐藏相关证书得上传和删除按钮
           $('.el-upload--picture-card').css({ display: 'none' })
           this.iswatch = false
           console.log('dxz')
           if (isedit != null) {
             this.iseditys = true
             if (fziseditys) {
               this.fziseditys = false
             }
             $('.iseditys').css({ 'pointer-events': 'none' })
             this.allyearnum.columns = [
               { field: 'year', title: '年份', width: '750px' },
               { field: 'money', title: '金额（万元）' },
               { field: 'money1', title: '调整金额（万元）' }
             ]
           } else {
             this.allyearnum.columns = [
               { field: 'year', title: '年份', width: '750px' },
               { field: 'money', title: '金额（万元）' }
             ]
           }
         } else {
           this.allyearnum.columns = [
             { field: 'year', title: '年份', width: '750px' },
             { field: 'money', title: '金额（万元）' }
           ]
           if (fziseditys) {
             this.fziseditys = false
           }
         }
       }
     } else if (JSON.parse(topicparam)) {
       this.topicid = JSON.parse(topicparam)
       if (this.topicid) {
         this.gettabledatinfo()
         if (iswatch != null) {
           $('.iseditys').css({ 'pointer-events': 'none' })
           this.iswatch = false
           console.log('dxz2')
           if (isedit != null) {
             this.iseditys = false
             $('.el-upload--picture-card').css({ display: 'none' })
             $(
               '.el-tabs__content .el-tab-pane .el-upload-list--picture-card .el-upload-list__item-actions .el-upload-list__item-delete'
             ).css({
               display: 'none !important'
             })

             if (fziseditys) {
               this.fziseditys = false
             }
             $('.iseditys').css({ 'pointer-events': 'none' })
             this.allyearnum.columns = [
               { field: 'year', title: '年份', width: '750px' },
               { field: 'money', title: '金额（万元）' },
               { field: 'money1', title: '调整金额（万元）' }
             ]
           } else {
             this.allyearnum.columns = [
               { field: 'year', title: '年份', width: '750px' },
               { field: 'money', title: '金额（万元）' }
             ]
           }
         }
       } else {
         this.allyearnum.columns = [
           { field: 'year', title: '年份', width: '750px' },
           { field: 'money', title: '金额（万元）' }
         ]
         if (fziseditys) {
           this.fziseditys = false
         }
       }
     }
     console.log('初次加载', this.iseditys, this.fziseditys)
   }
  private activeName = '数据表';
  private isShowDismiss = false
  private dqyear = '';
  private uploadid = '';
  private loading = false;
  private picloading = false;
  private uploadloading=false
  // 生成预算表按钮等待配置项
  private madeobj = {
    btdisable: false,
    isGeting: false,
    count: 10,
    getCode: '生成申报表',
    getYscode: '生成预算表',
    getRwsCode: '生成任务书'
  };

  private ktloading = false;
  private uploadktfj=false
  private uploadtzys=false
  private ktloadingtitle = '';
  private zcdisabled = false; // 提交成功后页面得暂存按钮禁用
  private baseurl = '';
  private iswatch = true;
  private fziseditys = true; // 预算调整附件上传时 监听该值 控制预算按钮的显示和隐藏
  private iseditys = false;
  private progressFlag: any = 0; // 动态显示进度条
  private loadProgress: any = false; // 关闭进度条
  private iseditys1 = false;
  private isshowagree = false; // 显示审核通过标签
  private isshowrefuse = false; // 显示预算驳回的提示
  private isshowysagree = false; // 显示审核预算通过标签
  private subbtn = 'info';
  private subisuse = true;
  private subysisuse = true;
  private jieduan = false;
  private jieduanupload = false;
  //copy14 andy 新增结题
  private jieti = false;
  private jietiupload = false;
  private jietidelete = false;
  private editorlist1: any = null; // ueditor编辑器1
  private editorlist2: any = null; // ueditor编辑器2
  private editorlist3: any = null; // ueditor编辑器3
  private subysbtn = 'info';
  private refuseobj: any = {
    content: '',
    fund: ''
  }; // 驳回预算后的内容
  private isystg = false;
  private copetabledata = {}; // 克隆得数据表
  private copedatatable = []; // 克隆的主要参与者
  private copepranter = []; // 克隆的协作单位
  private copepricdata = []; // 克隆的负责人表，预期研究成果，经费管理，
  private copejfgl = {}; // 克隆经费管理
  private copefilelist = [];
  private isfirstrequest = true;
  private copejfyslist = {}; // 监听经费预算资助金额
  private copeallyearlist = {}; // 监听经费预算年度经费预算
  private copeobj = ''; // 克隆的课题设计论证，研究基础及条件，单位意见，课题论证活页
  private copetopicname = '';
  private indexarray: any = []; // 存放提交表格时候空行得索引
  // tabs标签得配置项
  private tabsobj = {
    name: '',
    isshow: false
  };
  private topicid: any = '';
  private uploadData = [];
  private ysuploadData = [];
  private jduploadData = [];
  private jtuploadData = [];
  // 监听页面数据项是否发生变化
  private tabsbool: any = [
    { key: '数据表', isshow: false },
    { key: '负责人', isshow: false },
    { key: '相关证书', isshow: false },
    { key: '课题设计论证', isshow: false },
    { key: '研究基础及条件', isshow: false },
    { key: '预期研究成果', isshow: false },
    { key: '经费预算', isshow: false },
    { key: '经费管理', isshow: false },
    { key: '单位意见', isshow: false },
    { key: '课题论证活页', isshow: false },
    { key: '提交课题', isshow: false }
  ];
  private yqzoptions = [
    {
      label: 'A.专著',
      value: 'A.专著'
    },
    {
      label: 'B.译著',
      value: 'B.译著'
    },
    {
      label: 'C.研究论文',
      value: 'C.研究论文'
    },
    {
      label: 'D.研究报告',
      value: 'D.研究报告'
    },
    {
      label: 'E.工具书',
      value: 'E.工具书'
    },
    {
      label: 'F.电脑软件',
      value: 'F.电脑软件'
    },
    {
      label: 'G.其它',
      value: 'G.其它'
    }
  ];
  private chooseclass: any = [];
  private ruleForm: any = {
    filelist: [],
    fileid: '',
    visible: false,
    bhvisible: false,
    jdvisible: false,
    jtvisible: false
  };
  private jfysForm: any = {
    account: '',
    bank: '',
    id: '',
    payee: '',
    phone: '',
    state: 3,
    place: '',
    topicid: ''
  };
  private entrustment = [
    {
      label: '党政办',
      value: '0'
    },
    {
      label: '人事处',
      value: '1'
    },
    {
      label: '财务处',
      value: '2'
    },
    {
      label: '医师资格考试命题处',
      value: '3'
    },
    {
      label: '考务管理处',
      value: '4'
    },
    {
      label: '专业技术资格考试处',
      value: '5'
    },
    {
      label: '专项考试处',
      value: '6'
    },
    {
      label: '职业技能指导处',
      value: '7'
    },
    {
      label: '考试信息技术处',
      value: '8'
    },
    {
      label: '考试质量研究评价处',
      value: '9'
    },
    {
      label: '对外合作处（科创办）',
      value: '10'
    }
  ];
  private dataForm: any = {
    entrustment: '11',
    administrative: '', // 行政职务 ,
    administrative2: '', // 第二负责人行政职务 ,
    birthday: '', // 出生日期
    birthday2: '', // 第二出生日期
    // 协助单位集合
    cooperativeInfoList: [
      // {
      //   contacts: "",
      //   id: "",
      //   num: "",
      //   phone: "",
      //   property: "",
      //   workname: "",
      // },
    ],
    guideid: '', // 中心选题数据
    id: '', // 数据表id
    level: '', // 层级
    num: '',
    state: '', // 课题状态
    topictype: '0', // 选题方向 0中心选题 1自主选题
    updatetime: '',
    userId: '',
    degree: '', // 学位
    degree2: '', // 学位2
    donetime: '', // 预计完成时间 ,
    educationbg: '', // 学历
    educationbg2: '', // 学历2
    email: '', // 邮箱
    email2: '', // 邮箱2
    expenditure: 0, // 申请自主经费（单位：万元）
    finalresult: [], // 预期最终结果
    headname: '', // 负责人姓名
    headname2: '', // 负责人姓名2
    identity: '', // 身份证
    identity2: '', // 身份证2
    job: '', // 专业职务
    job2: '', // 专业职务2
    keyword: '', // 关键字
    nation: '', // 民族
    nation2: '', // 民族2
    phone: '', // 联系电话
    phone2: '', // 联系电话2
    postcode: '', // 邮编
    postcode2: '', // 邮编2
    provincename: '', // 所在省
    provincename2: '', // 所在省2
    provincenum: '', // 所在省编号
    provincenum2: '', // 所在省编号2
    rolename: '', // 担任导师名称
    rolename2: '', // 担任导师名称2
    rolenum: '', // 担任导师编号
    rolenum2: '', // 担任导师编号2
    sex: 0, // 性别
    sex2: 0, // 性别2
    speciality: '', // 研究专长
    speciality2: '', // 研究专长2
    systemname: '', // 所属系统名称
    systemname2: '', // 所属系统名称2
    systemnum: '', // 所属系统编号
    systemnum2: '', // 所属系统编号2
    // 主要参与者集合
    topicdatadetailList: [
      // {
      //   degree: "", //学位
      //   educationbg: "", //学历
      //   id: "", //id
      //   job: "", //专业职务
      //   name: "", //姓名
      //   phone: "", //联系方式
      //   speciality: "", //研究专长
      //   work: "", //工作单位
      // },
    ],
    topicid: '', // 课题id
    topicname: '', // 课题名称
    work: '', // 工作单位
    work2: '', // 第二负责人工作单位
    workaddress: '', // 工作单位通讯地址
    workaddress2: '' // 工作单位通讯地址
  };
  private tabledataobj = {
    systeminput: '',
    cityinput: '',
    projectisshow: true, // 课题方向是否显示
    weituoShow: false, // 委托选题
    personshow: false, // 第二负责人填写是否显示
    sylength: 7000 // 富文本框剩余输入字数
  };
  private uploadobj: any = {
    visible: false,
    fileSizeIsSatisfy: [],
    handlefileSatisfy: []
  };

  private tableissave = false; // 保存按钮是否显示
  private tableCellClickRowIndex: any = null; // 点击的单元格行索引
  private tableCellClickColumnIndex: any = null; // 点击的单元格列索引
  // 参与者列表数据源
  private datatable: any = {
    sel: null, // 选中行
    columns: [
      { field: 'name', title: '姓名' },
      { field: 'burndate', title: '出生年月' },
      { field: 'job', title: '专业职务' },
      { field: 'speciality', title: '研究专长' },
      { field: 'educationbg', title: '学历' },
      { field: 'degree', title: '学位' },
      { field: 'work', title: '工作单位' },
      { field: 'phone', title: '联系方式' }
    ],
    data: []
  };
  // 协作单位数据源
  private partner: any = {
    sel: null, // 选中行
    columns: [
      { field: 'workname', title: '单位名称' },
      { field: 'property', title: '单位性质' },
      { field: 'contacts', title: '联系人' },
      { field: 'phone', title: '联系方式' }
    ],
    data: []
  };
  // 负责人数据源
  private principal: any = {
    sel: null, // 选中行
    columns: [
      { field: 'host', title: '主持人' },
      { field: 'topicname', title: '课题名称' },
      { field: 'topiclevel', title: '课题级别' },
      { field: 'authorizetime', title: '批准时间' },
      { field: 'authorizeorganization', title: '批准单位' },
      { field: 'situation', title: '完成情况' }
    ],
    data: []
  };
  // 年度经费预算金额
  private allyearnum: any = {
    sel: null, // 选中行
    columns: [
      { field: 'year', title: '年份', width: '750px' },
      { field: 'money', title: '金额（万元）' }
    ],
    data: []
  };

  // 经费预算数据源
  private budgetdata: any = {
    sel: null, // 选中行
    id: '',
    idupdate: '', // 驳回预算后得重新提交得id
    columns: [
      { field: 'expense', title: '经费开支项目' },
      { field: 'money', title: '金额（万元）' },
      { field: 'description', title: '经费开支说明' }
    ],
    data: [
      {
        id: '',
        expense: '办公费',
        money: '0',
        money1: '0',
        description: '反映单位购买日常办公用品、书报杂志等支出'
      },
      {
        id: '',
        expense: '印刷费',
        money: '0',
        money1: '0',
        description: '反映单位的印刷费支出'
      },
      {
        id: '',
        expense: '咨询费',
        money: '0',
        money1: '0',
        description: '反映单位咨询方面的支出'
      },
      {
        id: '',
        expense: '邮电费',
        money: '0',
        money1: '0',
        description:
          '反映单位开支的信函、包裹、货物等物品的邮寄费及电话费、电报费、传真费、网络通讯费等'
      },
      {
        id: '',
        expense: '差旅费',
        money: '0',
        money1: '0',
        description:
          '反映单位工作人员国（境）内出差发生的城市间交通费、住宿费、伙食补助费和市内交通费'
      },
      {
        id: '',
        expense: '会议费',
        money: '0',
        money1: '0',
        description:
          '反映单位在会议期间按规定开支的住宿费、伙食费、会议场地租金、交通费、文件印刷费、医药费等'
      },
      {
        id: '',
        expense: '培训费',
        money: '0',
        money1: '0',
        description:
          '反映除因公出国（境）培训费以外的，在培训期间发生的师资费、住宿费、伙食费、培训场地费、培训资料费、交通费等各类培训费用'
      },
      {
        id: '',
        expense: '劳务费',
        money: '0',
        money1: '0',
        description:
          '反映支付给外单位和个人的劳务费用，如临时聘用人员、钟点工工资、稿费、翻译费、评审费等'
      },
      {
        id: '',
        expense: '其他商品和服务支出',
        money: '0',
        money1: '0',
        description:
          '反映上述科目未包括的日常公用支出。如诉讼费、国内组织的会员费、来访费、广告宣传费以及离休人员特需费、离退休人员公用经费等'
      }
    ],
    ptdata: [
      {
        width: '830px',
        id: '',
        money: '0',
        money1: '0'
      }
    ],
    hjdata: [
      {
        money: '0',
        money1: '0'
      }
    ]
  };
  // 预期研究成果数据源
  private expecteddata: any = {
    sel: null, // 选中行
    columns: [
      { field: 'finishtime', title: '完成时间' },
      { field: 'researchname', title: '最终成果名称' },
      { field: 'researchstyle', title: '成果形式' },
      { field: 'proctor', title: '负责人' }
    ],
    data: []
  };
  private validatePass2(rule, value, callback) {
    var arr = new Array()
    arr = value.split(' ')
    if (value === '') {
      callback(new Error('请输入关键词'))
    } else if (arr.length > 3) {
      callback(new Error('关键词不能超过三个(请检查是否多空格)'))
    } else {
      callback()
    }
  }
  private rules = {
    keyword: [
      { required: true, validator: this.validatePass2, trigger: 'blur' }
    ]
  };
  // 所属系统数组
  private systemlist = [
    {
      label: 'A.考区考点',
      value: 'A.考区考点'
    },
    {
      label: 'B.高校',
      value: 'B.高校'
    },
    {
      label: 'C.医院',
      value: 'C.医院'
    },
    {
      label: 'D.科研院所',
      value: 'D.科研院所'
    },
    {
      label: 'E.中医药行业学会',
      value: 'E.中医药行业学会'
    },
    {
      label: 'F.大型企业',
      value: 'F.大型企业'
    },
    {
      label: 'G.其它',
      value: 'G.其它'
    }
  ];
  // 最高学历数组
  private learnlist = [
    {
      label: '本科',
      value: '本科'
    },
    {
      label: '硕士研究生',
      value: '硕士研究生'
    },
    {
      label: '博士研究生',
      value: '博士研究生'
    },
    {
      label: '其它',
      value: '其它'
    }
  ];

  private degreelist = [
    {
      label: '学士',
      value: '学士'
    },
    {
      label: '硕士',
      value: '硕士'
    },
    {
      label: '博士',
      value: '博士'
    },
    {
      label: '其它',
      value: '其它'
    }
  ];
  private grouplist = [];

  private citylist = [];
  // 专业职务下拉项
  private zyzwlist = [
    {
      label: '教授',
      value: '教授'
    },
    {
      label: '副教授',
      value: '副教授'
    },
    {
      label: '讲师',
      value: '讲师'
    },
    {
      label: '助理讲师',
      value: '助理讲师'
    },
    {
      label: '研究员',
      value: '研究员'
    },
    {
      label: '副研究员',
      value: '副研究员'
    },
    {
      label: '助理研究员',
      value: '助理研究员'
    },
    {
      label: '研究实习员',
      value: '研究实习员'
    },
    {
      label: '主任医师',
      value: '主任医师'
    },
    {
      label: '副主任医师',
      value: '副主任医师'
    },
    {
      label: '主治（主管）医师',
      value: '主治（主管）医师'
    },
    {
      label: '医师、医士',
      value: '医师、医士'
    },
    {
      label: '主任药师',
      value: '主任药师'
    },
    {
      label: '副主任药师',
      value: '副主任药师'
    },
    {
      label: '主管药师',
      value: '主管药师'
    },
    {
      label: '药师、药士',
      value: '药师、药士'
    },
    {
      label: '主任护师',
      value: '主任护师'
    },
    {
      label: '副主任护师',
      value: '副主任护师'
    },
    {
      label: '护师、护士',
      value: '护师、护士'
    },
    {
      label: '主任技师',
      value: '主任技师'
    },
    {
      label: '副主任技师',
      value: '副主任技师'
    },
    {
      label: '主管技师',
      value: '主管技师'
    },
    {
      label: '技师、技士',
      value: '技师、技士'
    },
    {
      label: '教授级高级工程师',
      value: '教授级高级工程师'
    },
    {
      label: '高级工程师',
      value: '高级工程师'
    },
    {
      label: '工程师',
      value: '工程师'
    },
    {
      label: '助理工程师、技术员',
      value: '助理工程师、技术员'
    },
    {
      label: '其它',
      value: '其它'
    }
  ];
  private editor = {
    id: '',
    content: '',
    topicName: '',
    yjjccontent: '',
    ndktcontent: '',
    dwyjcontent:
      '  申请书所填写的内容属实；该课题负责人及参加者的政治和业务素质适合承担本课题的研究工作；本单位能提供完成本课题所需的时间和条件；本单位同意承担本项目的管理任务和信誉保证。'
  };

  private async downloadCommon(url, fileNameStr = '文件') {
    try {
      // this.uploadLoading = true
      const response = await fetch(url, {
        method: 'GET'
      })

      const blob = await response.blob()
      const objectUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl

      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0') // 月份从0开始，需+1并补0
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')

      // 从响应头读取后端设置的文件名
      const disposition = response.headers.get('Content-Disposition')
      let fileName = `${year}${month}${day}${hours}${minutes} ${fileNameStr}` // 初始文件名

      if (disposition) {
        // 匹配后端返回的 filename（兼容不同格式）
        const match = disposition.match(/filename="?([^";]+)"?/)
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1])
        }
      }

      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(objectUrl) // 释放内存
    } catch (error) {
      this.$message.error('下载文件失败，请稍后重试')
    } finally {
      // this.uploadLoading = false
    }
  }
  // unditor加载完成
  private UEeditorready1(editor) {
    let isdisabled = this.iswatch && !this.iseditys
    if (editor != null) {
      this.editorlist1 = editor
      if (!isdisabled) {
        editor.setDisabled()
      }
    }
  }
  // unditor加载完成
  private UEeditorready2(editor) {
    let isdisabled = this.iswatch && !this.iseditys
    if (editor != null) {
      this.editorlist2 = editor
      if (!isdisabled) {
        editor.setDisabled()
      }
    }
  }
  // unditor加载完成
  private UEeditorready3(editor) {
    let isdisabled = this.iswatch && !this.iseditys
    if (editor != null) {
      this.editorlist3 = editor
      if (!isdisabled) {
        editor.setDisabled()
      }
    }
  }
  private getguidelist() {
    let param = {
      content: '',
      isuse: 1,
      limit: 1,
      page: 1
    }
    getguidlist(param).then((res) => {
      if (res.code === 200) {
        let data = res.data.itemBeanList[0][0].itemBeanList
        data.forEach((res) => {
          let obj: any = {
            label: res.num + '.' + res.content,
            value: res.id
          }
          this.chooseclass.push(obj)
        })
      }
    })
  }
  private submitform() {
    let param = {
      id: this.topicid
    }
    if (this.uploadData.length === 0) {
      this.$message.warning('请上传附件')
    } else {
      let topicinfo = JSON.parse(sessionStorage.getItem('topicinfo') as any)
      // isrefuse=0 第一次上传申报内容  isrefuse=1驳回预算后重新上传
      gettpoicinfo(param).then((res) => {
        if (res.code === 200) {
          let updateparam = {
            guideid: res.data.guideid,
            id: res.data.id,
            isdelete: res.data.isdelete,
            level: res.data.level,
            num: res.data.num,
            state: 0,
            isrefuse: topicinfo === null ? '0' : topicinfo.isrefuse,
            topicName: res.data.name,
            topictype: res.data.topictype,
            updatetime: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
            userId: res.data.userid,
            dismiss: res.data.dismiss,
            fund: res.data.fund
          }
          console.log("确认num" + updateparam.num)
          updatetopic(updateparam).then((res) => {
            if (res.code == 200) {
              this.$message.success('课题提交成功')
              this.iswatch = false
              //copy14 andy
              this.jietidelete= false
              window.sessionStorage.setItem('iswatch', 'true')
            }
          })
        }
      })
    }
  }

  private submitrefuseform() {
    let param = {
      id: this.topicid
    }
    if (this.uploadData.length === 0) {
      this.$message.warning('请上传附件')
    } else {
      // isrefuse=0 第一次上传申报内容  isrefuse=1驳回预算后重新上传
      gettpoicinfo(param).then((res) => {
        if (res.code === 200) {
          let updateparam = {
            guideid: res.data.guideid,
            id: res.data.id,
            isdelete: res.data.isdelete,
            level: res.data.level,
            num: res.data.num,
            state: 0,
            isrefuse: 1,
            topicName: res.data.name,
            topictype: res.data.topictype,
            updatetime: moment(new Date()).format('YYYY-MM-DD hh:mm:ss'),
            userId: res.data.userid,
            dismiss: res.data.dismiss,
            fund: res.data.fund
          }
          console.log("确认num" + updateparam.num)
          updatetopic(updateparam).then((res) => {
            if (res.code == 200) {
              this.$message.success('预算调整附件提交成功')
              this.fziseditys = false
              window.sessionStorage.setItem('fziseditys', 'false')
            }
          })
        }
      })
    }
  }
  private ueConfig = {
    // 编辑器不自动被内容撑高
    autoHeightEnabled: false,
    // 初始容器高度
    initialFrameHeight: 595,
    // 初始容器宽度
    initialFrameWidth: 691,
    // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
    serverUrl: '',
    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli2.0 生成的项目，通常不需要设置该选项，默认是：UEDITOR_HOME_URL: '/static/UEditor/'
    // 但是 vue cli 3.x 生成的项目中，默认值是 process.env.BASE_URL + 'UEditor/'，如果项目不是部署在根目录下，则需要自己配置路径，我的项目是在根目录下，手动下载的UEditor放在了public目录下
    UEDITOR_HOME_URL: '/ueditor/',
    // 自定义菜单
    toolbars: [
      [
        'undo', // 撤销
        'redo', // 重做
        'underline', // 下划线
        'strikethrough', // 删除线
        'fontborder', // 字符边框
        // "source", //源代码
        'subscript', // 下标
        'superscript', // 上标
        'formatmatch', // 格式刷
        'selectall', // 全选
        'preview', // 预览
        // "horizontal", //分隔线
        'cleardoc', // 清空文档
        'indent', // 首行缩进
        'bold', // 加粗
        'italic', // 斜体
        'fontfamily', // 字体
        'fontsize', // 字号
        'paragraph', // 段落格式
        'pagebreak', // 分页
        'insertframe', // 插入Iframe
        'searchreplace', // 查询替换
        'justifyleft', // 居左对齐
        'justifyright', // 居右对齐
        'justifycenter', // 居中对齐
        'justifyjustify', // 两端对齐
        'forecolor', // 字体颜色
        'backcolor', // 背景色
        'insertorderedlist', // 有序列表
        'insertunorderedlist', // 无序列表
        // "fullscreen", //全屏
        'directionalityltr', // 从左向右输入
        'directionalityrtl', // 从右向左输入
        'rowspacingtop', // 段前距
        'rowspacingbottom', // 段后距
        'imagenone', // 默认
        'imageleft', // 左浮动
        'imageright', // 右浮动
        // "attachment", //附件
        'imagecenter', // 居中
        'lineheight', // 行间距
        'edittip ', // 编辑提示
        // "customstyle", //自定义标题
        // "autotypeset", //自动排版
        'tolowercase', // 字母小写
        'inserttable', // 插入表格
        'charts' // 图表
      ]
    ]
  };
  returnWaring(activeName, oldActiveName) {
    return this.$confirm(
      '离开将不保存' + oldActiveName + '页修改,请先暂存数据,是否确认离开？',
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
      .then(() => {
        this.tabsbool.forEach((res, index) => {
          if (oldActiveName == res.key) {
            res.isshow = false
            let topicparam = window.sessionStorage.getItem('topicid') as any
            let index_
            // if topicparam.topicId存在是编辑  不存在是新增
            if (JSON.parse(topicparam).topicId) {
              this.getdataslist(activeName)
              for (let i in this.tabsbool) {
                if (oldActiveName == this.tabsbool[i].key) {
                  index_ = i
                }
              }
              // this.emptydeclare(index_);
            } else {
              for (let i in this.tabsbool) {
                if (oldActiveName == this.tabsbool[i].key) {
                  index_ = i
                }
              }
              // this.emptydeclare(index_);
            }
          }
        })
      })
      .catch(() => {
        throw new Error('取消成功！')
      })
  }
  leaveTabs(activeName, oldActiveName) {
    for (let i in this.tabsbool) {
      if (oldActiveName == this.tabsbool[i].key) {
        if (this.tabsbool[i].isshow) {
          return this.returnWaring(activeName, oldActiveName)
        } else {
          this.getdataslist(activeName)
        }
      }
    }
  }
  // 获取经费管理
  getjfgl() {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid
    }
    getjfglinfo(userinfo).then((res) => {
      if (res.code === 200) {
        if (res.data != null) {
          this.jfysForm = res.data
          this.copejfgl = _.clone(this.jfysForm)
        } else {
          this.jfysForm = {
            account: '',
            bank: '',
            id: '',
            payee: '',
            phone: '',
            state: 3,
            place: '',
            topicid: ''
          }
          let assignjfys = {
            account: '',
            bank: '',
            id: '',
            payee: '',
            phone: '',
            state: 3,
            place: '',
            topicid: ''
          }
          this.copejfgl = _.clone(assignjfys)
        }
      }
    })
  }
  getdataslist(activeName) {
    if (activeName == '负责人') {
      this.getprincipalinfo(getmajorinfo, 'principal', 0)
    } else if (activeName == '课题设计论证') {
      this.getobjsinfo(getdesigninfo, 'content')
    } else if (activeName == '研究基础及条件') {
      this.getobjsinfo(getbasicsinfo, 'yjjccontent')
    } else if (activeName == '预期研究成果') {
      this.getprincipalinfo(getyqyjcginfo, 'expecteddata', 1)
    } else if (activeName == '经费预算') {
      this.getbudgetinfo()
    } else if (activeName == '经费管理') {
      this.getjfgl()
    } else if (activeName == '单位意见') {
      this.getobjsinfo(getopinioninfo, 'dwyjcontent')
    } else if (activeName == '课题论证活页') {
      this.getobjsinfo(getndktlzinfo, 'ndktcontent')
    } else if (activeName == '数据表') {
      this.gettabledatinfo()
    } else if (activeName == '相关证书') {
      this.getciterinfo()
    } else if (activeName == '提交课题') {
      this.getktlzsj()
    }
  }
  handleClick(val, index) {}
  changesystem(val) {
    this.tabledataobj.systeminput = val
  }
  changecity(val) {
    this.tabledataobj.cityinput = val
  }
  changeradio(val) {
    console.log(val)
    if (val === '1') { // 自主
      this.dataForm.entrustment = ''
      this.tabledataobj.projectisshow = false
      this.tabledataobj.weituoShow = false
      this.dataForm.guideid = ''
    } else if (val === '0') { // 中心
      this.tabledataobj.projectisshow = true
      this.tabledataobj.weituoShow = false
      this.dataForm.entrustment = ''
    } else {
      this.tabledataobj.projectisshow = false
      this.tabledataobj.weituoShow = true
      this.dataForm.guideid = ''
    }
  }
  // 折叠填写负责人
  showsecondper() {
    if (!this.tabledataobj.personshow) {
      this.tabledataobj.personshow = true
    } else {
      this.$confirm(
        '离开将不保存您填写的第二负责人数据，是否确认离开?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.tabledataobj.personshow = false
          this.dataForm.administrative2 = ''
          this.dataForm.birthday2 = ''
          this.dataForm.degree2 = ''
          this.dataForm.email2 = ''
          this.dataForm.headname2 = ''
          this.dataForm.identity2 = ''
          this.dataForm.job2 = ''
          this.dataForm.nation2 = ''
          this.dataForm.phone2 = ''
          this.dataForm.postcode2 = ''
          this.dataForm.provincename2 = ''
          this.dataForm.provincenum2 = ''
          this.dataForm.rolenum2 = ''
          this.dataForm.sex2 = 0
          this.dataForm.speciality2 = ''
          this.dataForm.systemname2 = ''
          this.dataForm.systemnum2 = ''
          this.dataForm.work2 = ''
          this.dataForm.workaddress2 = ''
        })
        .catch(() => {})
    }
  }
  tableCellClick(row, column, cell, event) {
    this.tableCellClickRowIndex = row.index
    this.tableCellClickColumnIndex = column.index
  }
  /** **-----------------表格输入框处理方法开始------------------------*****/
  readMasterUser(dataresouce) {
    // 根据实际情况，自己改下啊
    this[dataresouce].data.map((i) => {
      i.id = i.id // 模拟后台插入成功后有了id
      i.isset = false // 给后台返回数据添加`isset`标识
      return i
    })
  }
  // 添加表格输入框input数据
  addMasterUser(dataresouce: any) {
    for (let i of this[dataresouce].data) {
      if (i.isset) return this.$message.warning('请先保存当前编辑项')
    }
    let j = {}
    if (dataresouce) {
      if (dataresouce !== 'allyearnum') {
        if (this[dataresouce].data.length > 19) {
          this.$message.warning('当前最多添加20条')
          return false
        }
      } else {
        if (this[dataresouce].data.length > 4) {
          this.$message.warning('年度经费预算最多允许添加5条')
          return false
        }
      }
    }

    // datasource接收的是表格绑定的数据源名称,根据datasource判断push的对象格式
    if (dataresouce == 'datatable') {
      j = {
        id: new Date().getTime(),
        name: '',
        burndate: '',
        job: '',
        speciality: '',
        educationbg: '',
        degree: '',
        work: '',
        phone: '',
        isset: true
      }
    } else if (dataresouce == 'partner') {
      j = {
        id: new Date().getTime(),
        workname: '',
        property: '',
        fete: '',
        contacts: '',
        phone: '',
        num: '',
        isset: true
      }
    } else if (dataresouce == 'principal') {
      j = {
        id: new Date().getTime(),
        host: '',
        topicname: '',
        topiclevel: '',
        authorizetime: '',
        authorizeorganization: '',
        situation: '',
        isset: true
      }
    } else if (dataresouce == 'expecteddata') {
      j = {
        id: new Date().getTime(),
        finishtime: '',
        researchname: '',
        researchstyle: '',
        proctor: '',
        isset: true
      }
    } else if (
      dataresouce == 'allyearnum' &&
      !this.iseditys &&
      this.fziseditys
    ) {
      j = {
        id: new Date().getTime(),
        year: '',
        money: '',
        isset: true
      }
    }
    // 处理第一次年度预费经费未提交，管理员驳回预算后，新增年度经费预算
    else if (dataresouce == 'allyearnum' && this.iseditys && this.fziseditys) {
      j = {
        id: new Date().getTime(),
        year: '',
        money: '0',
        money1: '',
        isset: true,
        isrefuseset: 0 // 根据isrefuseset判断 新增的驳回预算数据是否可以删除
      }
    }
    this[dataresouce].data.push(j)
    this[dataresouce].sel = JSON.parse(JSON.stringify(j))
  }
  // andy start
  //================ 上移 ===================
    upindex(index, row) {
      if (index > 0) {
        let upDate = this.datatable.data[index - 1];
        this.datatable.data.splice(index - 1, 1);
        this.datatable.data.splice(index, 0, upDate);
      } else {
        this.$message.warning("已经是第一条了！");
        return false;
      }
    }

  //================ 下移 ===================
    downindex(index, row) {
      if (index + 1 === this.datatable.data.length) {
        this.$message.warning("已经是最后一条了！");
        return false;
      } else {
        let downDate = this.datatable.data[index + 1];
        this.datatable.data.splice(index + 1, 1);
        this.datatable.data.splice(index, 0, downDate);
      }
    }
  //andy end
  // 修改表格输入框
  personChange(dataresouce, row, index, cg) {
    // 点击修改 判断是否已经保存所有操作
    row.id = new Date().getTime()
    for (let i of this[dataresouce].data) {
      if (i.isset && i.id != row.id) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }
    }
    // 是否是取消操作

    if (!cg) {
      if (String(this[dataresouce].sel.id).length === 13) {
        let copesource = _.clone(this[dataresouce].sel)
        delete copesource.id
        // delete copesource.isset;
        for (let i in copesource) {
          console.log(copesource)
          if (copesource[i] === true) {
            this[dataresouce].data.splice(index, 1)
            return (row.isset = !row.isset)
          }
        }
      }

      // this[dataresouce].data.splice(index, 1);
    }
    // 提交数据
    if (row.isset) {
      if (this[dataresouce].data.length > 20) {
        this.$message.warning('当前最多添加20个')
      } else {
        // 项目是模拟请求操作  自己修改下
        let data = JSON.parse(JSON.stringify(this[dataresouce].sel))
        for (let k in data) row[k] = data[k]
        // 然后这边重新读取表格数据
        this.readMasterUser(dataresouce)
        row.isset = false
      }
    } else {
      this[dataresouce].sel = JSON.parse(JSON.stringify(row))
      row.isset = true
    }
  }

  // 删除表格输入框input表格方法
  handledelete(dataresouce, index) {
    this.$confirm('确定删除这条数据吗, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this[dataresouce].data.splice(index, 1)
      })
      .catch(() => {})
  }
  /** **-----------------表格输入框处理方法结束------------------------*****/
  // beforeAvatarUpload(file) {
  //   const isJPG = file.type === "image/jpeg";
  //   const isLt2M = file.size / 1024 / 1024 < 2;
  //   if (!isJPG) {
  //     this.$message.error("上传头像图片只能是 JPG 格式!");
  //   }
  //   if (!isLt2M) {
  //     this.$message.error("上传头像图片大小不能超过 6MB!");
  //   }
  //   return isJPG && isLt2M;
  // }
  // 文件上传方法
  fileOnChange(file: any, fileList) {
    const isLt2M = file.size > 512000
    const filelength = fileList.length
    if (isLt2M) {
      this.$message.warning('上传图片大小不能超过 500k!')
      fileList.splice(-1, 1) // 移除选中图片
      return false
    } else {
      this.uploadobj.fileSizeIsSatisfy.push(file)
    }
  }
  handleClose() {
    this.uploadobj.visible = false
  }

  handlePictureCardPreview(file) {
    this.uploadobj.visible = true
    this.uploadobj.url = file.url
  }

  // 修改经费预算属性
  editProperty(row, index, data_) {
    if (row.money == '') {
      row.money = 0
    }
    // 我这边是表格数据都是前端处理，需要把旧值存起来，用户点击修改之后修改了原来的数据，但是又点了取消的情况，还需要获取到原来的值
    sessionStorage.setItem('oldPropertValue', row.money)
    // // money为ture展示输入框
    this.$set(data_[index], 'isEditPropertyShow', true)
  }
  // 保存经费预算属性
  saveProperty(row, index, data_, type) {
    this.$set(data_[index], 'isEditPropertyShow', false)
    if (row.money == '') {
      row.money = 0
    } else if (row.money1 == '') {
      row.money1 = 0
    }
    let money_: number = 0
    let money1_: number = 0
    let momey2_: number = 0
    this.budgetdata.data.forEach((res) => {
      money_ += Number(res.money)
    })
    money_ += Number(this.budgetdata.ptdata[0].money)
    this.budgetdata.hjdata[0].money = parseFloat(money_.toFixed(10))

    // 调整预算时候
    if (this.iseditys) {
      let newarr: any = []
      this.budgetdata.data.forEach((res) => {
        money1_ += Number(res.money1)
      })
      newarr.push(this.budgetdata.ptdata[0].money1)
      momey2_ += Number(this.budgetdata.ptdata[0].money1)
      let moneyresult = money1_
      if (Number(moneyresult.toFixed(3)) > Number(this.refuseobj.fund)) {
        this.$message.warning('预算调整金额不能大于预算调整额度')
        this.budgetdata.data[index].money1 = 0
      } else {
        this.budgetdata.hjdata[0].money1 =
          parseFloat(moneyresult.toFixed(10)) + parseFloat(momey2_.toFixed(10))
      }
    }
  }
  // 取消经费预算属性
  cancelProperty(row, index, data_) {
    if (sessionStorage.getItem('oldPropertValue') !== 'null') {
      this.$set(
        data_[index],
        'money',
        sessionStorage.getItem('oldPropertValue')
      )
    } else {
      this.$set(data_[index], 'money', 0)
    }
    this.$set(data_[index], 'isEditPropertyShow', false)
  }
  // 显示富文本框剩余字数
  descInput() {
    // this.tabledataobj.sylength = 7000 - texval;
  }
  handleRemove(file, filelist) {
    this.uploadobj.fileSizeIsSatisfy = filelist
  }
  // 暂存数据表内容
  savedatatable() {
    console.log(123)
    console.log(this.dataForm.entrustment)
    // 0待审核 1审核通过 2已撤回 3未提交 4驳回预算 5驳回
    if (this.datatable.data.length != 0) {
      this.datatable.data.forEach((res, index) => {
        if (String(res.id).length == 13) {
          res.id = ''
        }
        res.isset = 0
        res.seq = index + 1
      })
    }
    if (this.partner.data.length != 0) {
      this.partner.data.forEach((res) => {
        if (String(res.id).length == 13) {
          res.id = ''
        }
        res.isset = 0
      })
    }
    this.dataForm.topicdatadetailList = this.datatable.data
    this.dataForm.cooperativeInfoList = this.partner.data
    this.dataForm.cooperativeInfoList.forEach((res, index) => {
      res.num = index + 1
    })
    this.dataForm.isdelete = 0
    let params: any = window.sessionStorage.getItem('json')
    let params_: any = window.sessionStorage.getItem('topicid')
    if (JSON.parse(params_).topicId != null) {
      this.dataForm.topicid = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        this.dataForm.topicid = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    this.dataForm.userId = JSON.parse(params).data.id
    this.dataForm.state = 3; // 暂存得数据状态是3
    (this.$refs.dataForm as any).validate((valid) => {
      if (valid) {
        console.log('终',this.dataForm)
        // this.dataForm.finalresult = this.dataForm.finalresult.join(",");
        updateinfo(this.dataForm).then((res) => {
          if (res.code === 200) {
            this.$message.success('数据表数据暂存成功')
            this.gettabledatinfo()
            // this.dataForm.finalresult = this.dataForm.finalresult.split(",");
            this.tabsbool[0].isshow = false
          }
        })
      } else {
        return false
      }
    })
  }
  downjffile() {
    let title = ''
    let formadata = new FormData()
    formadata.append('topicId', this.topicid)
    var countDown = setInterval(() => {
      if (this.madeobj.count < 1) {
        this.madeobj.isGeting = false
        this.madeobj.btdisable = false
        this.madeobj.getYscode = '生成预算表'
        this.madeobj.count = 10
        clearInterval(countDown)
      } else {
        this.madeobj.isGeting = true
        this.madeobj.btdisable = true
        this.madeobj.getYscode = this.madeobj.count-- + 's后重发'
      }
    }, 1000)
    downloadjffile(formadata).then((res) => {
      if (res.code == 200) {
        this.$alert(
          '已成功向服务器发送课题文档的生成请求，请稍后尝试点击“下载预算表”按钮进行下载',
          '提示',
          {
            confirmButtonText: '确定'
          }
        )
      }
    })
  }
  createfile(type) {
    console.log('type', type)
    let title = ''
    let formadata = new FormData()
    formadata.append('topicId', this.topicid)
    var countDown = setInterval(() => {
      if (this.madeobj.count < 1) {
        this.madeobj.isGeting = false
        this.madeobj.btdisable = false
        if (type === 'rw') {
          this.madeobj.getRwsCode = '生成任务书'
        } else {
          this.madeobj.getCode = '生成申报表'
        }
        this.madeobj.count = 10
        clearInterval(countDown)
        console.log(1)
      } else {
        this.madeobj.isGeting = true
        this.madeobj.btdisable = true
        if (type === 'rw') {
          this.madeobj.getRwsCode = this.madeobj.count-- + 's后重发'
        } else {
          this.madeobj.getCode = this.madeobj.count-- + 's后重发'
        }
      }
    }, 1000)
    //adny 2022-06-20 start
    if(type === "rw"){
      downloadfile(formadata).then((res) => {
        if (res.code == 200) {
          this.$alert(
            '已成功向服务器发送课题文档的生成请求，请稍后尝试点击“下载任务书”按钮进行下载',
            '提示',
            {
              confirmButtonText: '确定'
            }
          )
        }else{
          this.$message.error(res.message)
        }
      })
    } else{
      downloadfileapplication(formadata).then((res) => {
        if (res.code == 200) {
          if (type === 'sb') {
            this.$alert(
              '已成功向服务器发送课题文档的生成请求，请稍后尝试点击“下载申报表”按钮进行下载',
              '提示',
              {
                confirmButtonText: '确定'
              }
            )
          }
        }else{
          this.$message.error(res.message)
        }
      })
    }
    //adny 2022-06-20 end
    // downloadfile(formadata).then((res) => {
    //   if (res.code == 200) {
    //     if (type === 'sb') {
    //       this.$alert(
    //         '已成功向服务器发送课题文档的生成请求，请稍后尝试点击“下载申报表”按钮进行下载',
    //         '提示',
    //         {
    //           confirmButtonText: '确定'
    //         }
    //       )
    //     } else {
    //       this.$alert(
    //         '已成功向服务器发送课题文档的生成请求，请稍后尝试点击“下载任务书”按钮进行下载',
    //         '提示',
    //         {
    //           confirmButtonText: '确定'
    //         }
    //       )
    //     }
    //   }
    // })
  }
  downfile(type_) {
    let param = {
      id: this.topicid
    }
    let sbdata: any = {} // 申报对象集合
    let ysdaya: any = {} // 预算对象集合
    downloadpdf(param).then((res) => {
      if (res.code == 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data
        // andy
        var isSuccess = 0;
        data_.forEach((res) => {
          if (res.state == 0) {
            isSuccess++;
          }
        })
        if(data_.length === isSuccess){
          this.$message.error('请确认附件是否满足生成条件！')
          return;
        }
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type == 0) {
            sbdata = res
          } else {
            ysdaya = res
          }
        })
        if (type_ == 0) {
          if (sbdata.state == 0) {
            this.$message.warning('请先点击"生成申报表"按钮生成申报表文档')
          } else if (sbdata.state == 1) {
            this.$message.warning('申报表正在生成中,请稍后下载')
          } else {
            sbdata.url = sbdata.url.split(',').shift()
            let href = (window as any).downloadurl +'/pdf/' + sbdata.url
            this.downloadCommon(href, '结题报告')

            console.log(href)
            // const savea = document.createElement('a')
            // savea.setAttribute('download', '申报表')
            // savea.href = href
            // savea.click()
          }
        } else {
          if (ysdaya.state == 0) {
            this.$message.warning('请先点击"生成申报表"按钮生成申报表文档')
          } else if (ysdaya.state == 1) {
            this.$message.warning('预算表正在生成中,请稍后下载')
          } else {
            let href = (window as any).downloadurl +'/pdf/' + ysdaya.url
            this.downloadCommon(href, '结题报告')
            // const savea = document.createElement('a')
            // savea.setAttribute('download', '预算表')
            // savea.href = href
            // savea.click()
          }
        }
      }
    })
  }
  watchfile(type_) {
    let param = {
      id: this.topicid
    }
    let sbdata: any = {} // 申报对象集合
    let ysdaya: any = {} // 预算对象集合
    downloadpdf(param).then((res) => {
      if (res.code == 200) {
        // state 0未生成 1生成中 2已生成
        let data_ = res.data
        // andy
        var isSuccess = 0;
        data_.forEach((res) => {
          if (res.state == 0) {
            isSuccess++;
          }
        })
        if(data_.length === isSuccess){
          this.$message.error('请确认附件是否满足生成条件！')
          return;
        }
        data_.forEach((res) => {
          // res.type=0 完整版pdf  =1预算pdf
          if (res.type == 0) {
            sbdata = res
          } else {
            ysdaya = res
          }
        })
        if (type_ == 0) {
          if (sbdata.state == 0) {
            this.$message.warning('请先点击"生成申报表"按钮生成申报表文档')
          } else if (sbdata.state == 1) {
            this.$message.warning('申报表正在生成中,请稍后预览')
          } else {
            sbdata.url = sbdata.url.split(',').shift()
            let href = (window as any).downloadurl +'/pdf/' + sbdata.url
            window.open(href, '_blank');
            // const savea = document.createElement('a')
            // // savea.setAttribute("download", "申报表");
            // savea.target = '_blank'
            // savea.href = href
            // savea.click()
          }
        } else {
          if (ysdaya.state == 0) {
            this.$message.warning('请先点击"生成预算表"按钮生成预算表文档')
          } else if (ysdaya.state == 1) {
            this.$message.warning('预算表正在生成中,请稍后预览')
          } else {
            let href = (window as any).downloadurl +'/pdf/' + ysdaya.url
            window.open(href, '_blank');
            // const savea = document.createElement('a')
            // savea.target = '_blank'
            // // savea.setAttribute("download", "预算表");
            // savea.href = href
            // savea.click()
          }
        }
      }
    })
  }

  downloadZip() {
    let href = (window as any).downloadurl +'/pdf/tellyesOut.zip'
    const savea = document.createElement('a')
    savea.download = '阶段汇报模板.zip'
    savea.href = href
    savea.click()
  }

  downloadJieTiZip() {
    let href = (window as any).downloadurl +'/pdf/tellyesJieTiOut.zip'
    const savea = document.createElement('a')
    savea.download = '结题汇报模板.zip'
    savea.href = href
    savea.click()
  }

  // 暂存相关证书
  savexgzs() {
    let formdata: any = new FormData()
    let topiciid = ''
    let params_: any = window.sessionStorage.getItem('topicid')
    let newarr: any = []
    let paramarr: any = []
    let bsfu = 0
    let content = ''

    if (JSON.parse(params_).topicId != null) {
      topiciid = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        topiciid = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    if (this.uploadobj.fileSizeIsSatisfy.length == 0) {
      this.$message.warning('当前未导入图片')
    } else {
      this.loading = true
      this.uploadobj.fileSizeIsSatisfy.forEach((res) => {
        if (res.raw) {
          formdata.append('file', res.raw)
          bsfu = 0
        } else {
          newarr.push(res)
          bsfu = 1
        }
      })
      newarr.forEach((res) => {
        let index = res.url.indexOf('=')
        let index_ = res.url.indexOf('&')
        paramarr.push(res.url.substring(index + 1, index_))
      })

      // 更新
      content = paramarr.join(',')
      if (content.length != 0) {
        let param = {
          id: this.uploadid,
          content: content
        }
        if (bsfu == 0) {
          updateuploadfile(param).then((res) => {
            if (res.code === 200) {
              formdata.append('tableType', 0)
              formdata.append('topicId', topiciid)
              formdata.append('state', 3)
              formdata.append('id', this.uploadid)
              formdata.append('fileType', 0)
              formdata.append('isdelete', 0)
              uploadzsxg(formdata).then((res) => {
                if (res.code == 200) {
                  this.loading = false
                  this.$message.success('证书上传成功')
                  // (this.$refs.uploadzs as any).clearFiles();
                  this.getciterinfo()
                  this.tabsbool[2].isshow = false
                }
              })
            }
          })
        } else if (bsfu == 1) {
          updateuploadfile(param).then((res) => {
            if (res.code == 200) {
              this.loading = false
              this.$message.success('证书上传成功')
              this.tabsbool[2].isshow = false
              // (this.$refs.uploadzs as any).clearFiles();
              this.getciterinfo()
            }
          })
        }
      } else {
        formdata.append('tableType', 0)
        formdata.append('topicId', topiciid)
        formdata.append('state', 3)
        formdata.append('id', '')
        formdata.append('fileType', 0)
        formdata.append('isdelete', 0)
        let param_ = {
          id: topiciid,
          content: ''
        }
        removefile(param_).then((res) => {
          uploadzsxg(formdata).then((res) => {
            if (res.code == 200) {
              this.loading = false
              this.$message.success('证书上传成功')
              this.tabsbool[2].isshow = false
              this.getciterinfo()
            }
          })
        })
      }
    }
  }
  // 暂存负责人内容
  saveprinci(type, datasource) {
    let topiciid = ''
    let params_: any = window.sessionStorage.getItem('topicid')
    let copedata: any = [] // cope得原数组
    if (JSON.parse(params_).topicId != null) {
      topiciid = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        topiciid = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    this[datasource].data.forEach((res) => {
      //  length=12是自己定义得id为时间戳 为了避免行内删除或者取消保存操作 兄弟对象受影响
      if (String(res.id).length == 13) {
        res.id = ''
      }
      res.isset = 0
      res.topicid = topiciid
    })
    let addparams: any = {
      state: 3
    }
    let index_ = 0
    if (this[datasource].data.length == 0) {
      this.$message.warning('当前表格没有插入数据')
    } else {
      if (type == 0) {
        addparams.majorTopicUpdateRequestList = this[datasource].data
        copedata = _.clone(addparams.majorTopicUpdateRequestList)
        addparams.majorTopicUpdateRequestList.forEach((item, index) => {
          item.seq = index + 1
        })
        addmajor(addparams).then((res) => {
          if (res.code === 200) {
            this.$message.success('负责人数据暂存成功')
            this.tabsbool[1].isshow = false
          }
        })
      } else {
        addparams.expectationresearchAddRequests = this[datasource].data
        addparams.expectationresearchAddRequests.forEach((res, index) => {
          res.num = index + 1
        })
        addyqyjcg(addparams).then((res) => {
          if (res.code === 200) {
            this.tabsbool[5].isshow = false
            this.$message.success('预期研究成果数据暂存成功')
          }
        })
      }
    }
  }
  // 暂存经费预算
  savejfys(type) {
    let topiciid = ''
    let params_: any = window.sessionStorage.getItem('topicid')
    if (JSON.parse(params_).topicId != null) {
      topiciid = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        topiciid = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    this.allyearnum.data.forEach((res) => {
      res.isset = 0
    })
    let addparam
    // type=0 正常新增
    if (type == 0) {
      addparam = {
        printingfee: Number(this.budgetdata.data[1].money), // 印刷费
        postandtele: this.budgetdata.data[3].money, // 邮电费
        descri: '',
        equipment: this.budgetdata.ptdata[0].money,
        id: this.budgetdata.id,
        itemList: this.allyearnum.data,
        officeexpenses: this.budgetdata.data[0].money, // 办公费
        trainingfee: this.budgetdata.data[6].money, // 培训费
        laborfee: this.budgetdata.data[7].money, // 劳务费
        othergoodsandservices: this.budgetdata.data[8].money, // 其他商品和支出
        conferencefee: this.budgetdata.data[5].money, // 会议费
        state: 3,
        topicid: topiciid,
        topmoney: '',
        sum: this.budgetdata.hjdata[0].money,
        consultationfee: this.budgetdata.data[2].money, // 咨询费
        type: 0,
        travelexpenses: this.budgetdata.data[4].money // 差旅费
      }
      let moneysum: number = 0
      addparam.itemList.forEach((item) => {
        moneysum += Number(item.money)
      })
      if (moneysum != Number(addparam.sum)) {
        this.$message.warning(
          '年度经费预算金额总和不等于合计金额，请调整年度经费预算金额'
        )
      } else {
        addbudget(addparam).then((res) => {
          if (res.code === 200) {
            this.$message.success('经费预算数据暂存成功')
            this.tabsbool[6].isshow = false
            this.getbudgetinfo()
          }
        })
      }
    }

    // type=1 驳回预算后新增
    else {
      let newdatalist: any = []
      if (this.allyearnum.data.length != 0) {
        this.allyearnum.data.forEach((res) => {
          let newobj = {
            id: '',
            money: res.money1,
            year: res.year
          }
          newdatalist.push(newobj)
        })
      }
      addparam = {
        printingfee: Number(this.budgetdata.data[1].money1),
        postandtele: this.budgetdata.data[3].money1,
        descri: '',
        equipment: this.budgetdata.ptdata[0].money1,
        id: this.budgetdata.idupdate,
        itemList: newdatalist,
        officeexpenses: this.budgetdata.data[0].money1,
        trainingfee: this.budgetdata.data[6].money1,
        laborfee: this.budgetdata.data[7].money1, // 劳务费
        othergoodsandservices: this.budgetdata.data[8].money1, // 其他商品和支出
        conferencefee: this.budgetdata.data[5].money1,
        state: 4,
        topicid: topiciid,
        topmoney: '',
        sum: this.budgetdata.hjdata[0].money1,
        consultationfee: this.budgetdata.data[2].money1,
        type: 1,
        travelexpenses: this.budgetdata.data[4].money1
      }

      let moneysum: number = 0
      addparam.itemList.forEach((item) => {
        if (item.money == undefined) {
          item.money = 0
        }
        moneysum += Number(item.money)
      })

      if (moneysum != Number(addparam.sum)) {
        this.$message.warning(
          '年度经费预算调整金额总和不等于调整预算金额总和，请调整年度经费预算调整金额'
        )
      } else {
        addbudget(addparam).then((res) => {
          if (res.code === 200) {
            this.$message.success('调整经费预算数据暂存成功')
            this.tabsbool[6].isshow = false
            this.getbudgetinfo()
          }
        })
      }
    }
  }
  // 暂存经费管理
  savejfgl() {
    let topiciid: any = ''
    let params_: any = window.sessionStorage.getItem('topicid')
    if (JSON.parse(params_).topicId != null) {
      topiciid = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        topiciid = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    this.jfysForm.topicid = topiciid;
    (this.$refs.jfysForm as any).validate((valid) => {
      if (valid) {
        addjfgl(this.jfysForm).then((res) => {
          if (res.code === 200) {
            this.$message.success('经费管理添加成功')
            this.tabsbool[7].isshow = false
          }
        })
      } else {
        return false
      }
    })
  }
  // 一键复制课题论证信息
  copektlz() {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid
    }
    this.ktloadingtitle = '课题论证信息复制中,请等待...'
    this.ktloading = true
    getdesigninfo(userinfo).then((res) => {
      if (res.code === 200) {
        if (res.data != null) {
          this.ktloading = false
          this.editor.ndktcontent = res.data.content
        }
      }
    })
  }
  // 暂存课题设计论证,课题基础及条件,课题论证活页
  savektlz(type) {
    let topiciid_ = ''
    let params_: any = window.sessionStorage.getItem('topicid')
    // console.log(JSON.parse(params_))
    if (JSON.parse(params_).topicId != null) {
      topiciid_ = JSON.parse(params_).topicId
    } else {
      if (JSON.parse(params_) != null) {
        topiciid_ = JSON.parse(params_)
      } else {
        this.$message.warning('个人信息失效，请重新登录')
        this.$router.push('/login')
        return false
      }
    }
    let param: any = {
      id: this.editor.id,
      topicid: topiciid_,
      state: 3
    }

    if (type == 0) {
      this.ktloading = true
      param.content = this.editor.content
      this.ktloadingtitle = '课题设计论证内容上传中'
      adddesign(param).then((res) => {
        if (res.code === 200) {
          this.ktloading = false
          this.$message.success('课题设计论证数据暂存成功')
          this.tabsbool[3].isshow = false
        }
      })
    } else if (type == 1) {
      this.ktloading = true
      param.content = this.editor.yjjccontent
      this.ktloadingtitle = '研究基础及条件内容上传中'
      addbasics(param).then((res) => {
        if (res.code === 200) {
          this.ktloading = false

          this.$message.success('研究基础及条件数据暂存成功')
          this.tabsbool[4].isshow = false
        }
      })
    } else if (type == 2) {
      param.content = this.editor.ndktcontent
      param.topicName = this.editor.topicName;
      (this.$refs.editorForm as any).validate((valid) => {
        if (valid == true) {
          this.ktloading = true
          this.ktloadingtitle = '课题论证活页数据内容上传中'
          addndktlz(param).then((res) => {
            if (res.code === 200) {
              this.ktloading = false
              this.$message.success('课题论证活页数据暂存成功')
              this.tabsbool[9].isshow = false
            }
          })
        } else {
          return false
        }
      })
    } else {
      param.content = this.editor.dwyjcontent
      addopinion(param).then((res) => {
        if (res.code === 200) {
          this.$message.success('暂存单位意见成功')
          this.tabsbool[8].isshow = false
        }
      })
    }
  }

  // 获取数据表内容
  gettabledatinfo() {
    let userinfo = {
      name: '',
      page: 1,
      limit: 10,
      topicId: this.topicid
    }
    gettableinfo(userinfo).then((res) => {
      if (res.code === 200) {
        let data_ = res.data
        if (data_ == null) {
          this.dataForm = {
            entrustment: '',
            administrative: '', // 行政职务 ,
            administrative2: '', // 第二负责人行政职务 ,
            birthday: '', // 出生日期
            birthday2: '', // 第二出生日期
            // 协助单位集合
            cooperativeInfoList: [
              // {
              //   contacts: "",
              //   id: "",
              //   num: "",
              //   phone: "",
              //   property: "",
              //   workname: "",
              // },
            ],
            guideid: '', // 中心选题数据
            id: '', // 数据表id
            level: '', // 层级
            num: '',
            state: '', // 课题状态
            topictype: '0', // 选题方向 0中心选题 1自主选题
            updatetime: '',
            userId: '',
            degree: '', // 学位
            degree2: '', // 学位2
            donetime: '', // 预计完成时间 ,
            educationbg: '', // 学历
            educationbg2: '', // 学历2
            email: '', // 邮箱
            email2: '', // 邮箱2
            expenditure: 0, // 申请自主经费（单位：万元）
            finalresult: [], // 预期最终结果
            headname: '', // 负责人姓名
            headname2: '', // 负责人姓名2
            identity: '', // 身份证
            identity2: '', // 身份证2
            job: '', // 专业职务
            job2: '', // 专业职务2
            keyword: '', // 关键字
            nation: '', // 民族
            nation2: '', // 民族2
            phone: '', // 联系电话
            phone2: '', // 联系电话2
            postcode: '', // 邮编
            postcode2: '', // 邮编2
            provincename: '', // 所在省
            provincename2: '', // 所在省2
            provincenum: '', // 所在省编号
            provincenum2: '', // 所在省编号2
            rolename: '', // 担任导师名称
            rolename2: '', // 担任导师名称2
            rolenum: '', // 担任导师编号
            rolenum2: '', // 担任导师编号2
            sex: 0, // 性别
            sex2: 0, // 性别2
            speciality: '', // 研究专长
            speciality2: '', // 研究专长2
            systemname: '', // 所属系统名称
            systemname2: '', // 所属系统名称2
            systemnum: '', // 所属系统编号
            systemnum2: '', // 所属系统编号2
            // 主要参与者集合
            topicdatadetailList: [
              // {
              //   degree: "", //学位
              //   educationbg: "", //学历
              //   id: "", //id
              //   job: "", //专业职务
              //   name: "", //姓名
              //   phone: "", //联系方式
              //   speciality: "", //研究专长
              //   work: "", //工作单位
              // },
            ],
            topicid: '', // 课题id
            topicname: '', // 课题名称
            work: '', // 工作单位
            work2: '', // 第二负责人工作单位
            workaddress: '', // 工作单位通讯地址
            workaddress2: '' // 工作单位通讯地址
          }
          this.partner.data = []
          this.datatable.data = []
          this.copetabledata = _.clone(this.dataForm)
          this.copedatatable = _.clone(this.datatable.data)
          this.copepranter = _.clone(this.partner.data)
        } else {
          if (data_.topictype === '1') { // 自主
            this.tabledataobj.projectisshow = false
            this.tabledataobj.weituoShow = false
          } else if (data_.topictype === '0') { // 中心
            this.tabledataobj.projectisshow = true
            this.tabledataobj.weituoShow = false
          } else {
            this.tabledataobj.projectisshow = false
            this.tabledataobj.weituoShow = true
          }
          data_.topicdata.finalresult = data_.topicdata.finalresult.split(',')
          this.dataForm = data_.topicdata
          this.dataForm.entrustment = data_.entrustment
          console.log('前',data_.topicdata)
          console.log('后',this.dataForm)
          this.dataForm.topictype = data_.topictype
          this.dataForm.guideid = data_.guideid
          if (data_.topicdata.administrative2 !== '') {
            this.tabledataobj.personshow = true
          }
          this.dataForm.cooperativeInfoList = data_.cooperativeList
          this.dataForm.finalresult = data_.finalresult
          this.dataForm.topicdatadetailList = data_.topicdatadetailList
          this.datatable.data = data_.topicdatadetailList
          this.partner.data = data_.cooperativeList
          // this.dataForm = JSON.parse(JSON.stringify(this.dataForm));
          this.copetabledata = _.clone(this.dataForm)
          this.copedatatable = _.clone(this.datatable.data)
          this.copepranter = _.clone(this.partner.data)
        }
      }
    })
  }

  // 获取经费预算内容
  async getbudgetinfo() {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid
    }

    await getbudgetinfo(userinfo).then((res) => {
      if (res.code === 200) {
        let data: any = {} // 未调整预算得数据  type=0
        let updatedata: any = {} // 调整预算后得数据   type=1
        if (res.data.length != 0) {
          res.data.forEach((res) => {
            if (res.type == 0) {
              data = res
            } else {
              updatedata = res
            }
          })
          let newArrays = Object.keys(data)
          let newArraysUpdate = Object.keys(updatedata)
          let newHandlearray1: any = [] // 处理正常提交返回的数组,这里后台返回的itemlist只有money,前台预算金额是moeny，调整预算金额是money1
          let newHandlearray2: any = [] // 存预算驳回返回的数组,这里后台返回的itemlist只有money,前台预算金额是moeny，调整预算金额是money1
          if (newArrays.length != 0) {
            data.itemList.forEach((res, i) => {
              let obj: any = {}
              obj.isset = 0
              obj.year = res.year
              obj.money = res.money
              newHandlearray1.push(obj)
            })
            this.budgetdata.data[1].money = data.printingfee
            this.budgetdata.data[3].money = data.postandtele
            this.budgetdata.ptdata[0].money = data.equipment
            this.budgetdata.id = data.id
            this.budgetdata.data[0].money = data.officeexpenses
            this.budgetdata.data[6].money = data.trainingfee
            this.budgetdata.data[7].money = data.laborfee
            this.budgetdata.data[8].money = data.othergoodsandservices
            this.budgetdata.data[5].money = data.conferencefee
            this.budgetdata.data[2].money = data.consultationfee
            this.budgetdata.hjdata[0].money = data.sum
            this.budgetdata.data[4].money = data.travelexpenses
            // 调整预算后的

            if (this.iseditys) {
              if (newArraysUpdate.length != 0) {
                updatedata.itemList.forEach((res, i) => {
                  let obj: any = {}
                  obj.isset = 0
                  obj.year = res.year
                  obj.money1 = res.money
                  newHandlearray2.push(obj)
                })
                // 将存放经费预算的数组内对象和存放调整经费预算的对象合并
                // array格式[{isset:0,year:'',moeny:'',money1:''}]
                var newhbarray = newHandlearray2.map((item, index) => {
                  return { ...item, ...newHandlearray1[index] }
                })
                for (let i in newhbarray) {
                  if (!newhbarray[i].money) {
                    newhbarray[i].money = ''
                  }
                }
                this.allyearnum.data = newhbarray
                // this.allyearnum.data = updatedata.itemList;
                this.budgetdata.data[1].money1 = updatedata.printingfee
                this.budgetdata.data[3].money1 = updatedata.postandtele
                this.budgetdata.ptdata[0].money1 = updatedata.equipment
                // this.budgetdata.idupdate = updatedata.id;
                this.budgetdata.idupdate = updatedata.id
                this.budgetdata.data[0].money1 = updatedata.officeexpenses
                this.budgetdata.data[6].money1 = updatedata.trainingfee
                this.budgetdata.data[7].money1 = updatedata.laborfee
                this.budgetdata.data[8].money1 =
                  updatedata.othergoodsandservices
                this.budgetdata.data[5].money1 = updatedata.conferencefee
                this.budgetdata.data[2].money1 = updatedata.consultationfee
                this.budgetdata.hjdata[0].money1 = updatedata.sum
                this.budgetdata.data[4].money1 = updatedata.travelexpenses
                this.copejfyslist = _.clone(this.budgetdata)
                this.copeallyearlist = _.clone(this.allyearnum.data)
              } else {
                data.itemList.forEach((res, i) => {
                  let obj: any = {}
                  obj.isset = 0
                  obj.year = res.year
                  obj.money = res.money
                  newHandlearray2.push(obj)
                })
                // 将存放经费预算的数组内对象和存放调整经费预算的对象合并
                // array格式[{isset:0,year:'',moeny:'',money1:''}]
                var newhbarray = newHandlearray2.map((item, index) => {
                  return { ...item, ...newHandlearray1[index] }
                })
                for (let i in newhbarray) {
                  if (!newhbarray[i].money) {
                    newhbarray[i].money1 = ''
                  }
                }
                this.allyearnum.data = newhbarray
                this.copeallyearlist = _.clone(this.allyearnum.data)
                this.copejfyslist = _.clone(this.budgetdata)
              }
              this.copejfyslist = _.clone(this.budgetdata)
              this.copeallyearlist = _.clone(this.allyearnum.data)
            } else {
              // array格式[{isset:0,year:'',moeny:''}]
              this.allyearnum.data = newHandlearray1
              this.copeallyearlist = _.clone(this.allyearnum.data)
              this.copejfyslist = _.clone(this.budgetdata)
            }
          } else {
            if (updatedata.itemList.length > 0) {
              updatedata.itemList.forEach((res, i) => {
                let obj: any = {}
                obj.isset = 0
                obj.year = res.year
                obj.money1 = res.money
                newHandlearray2.push(obj)
              })
              // 将存放经费预算的数组内对象和存放调整经费预算的对象合并
              // array格式[{isset:0,year:'',moeny:'',money1:''}]

              for (let i in newHandlearray2) {
                if (!newHandlearray2[i].money) {
                  newHandlearray2[i].money = ''
                }
              }
              this.allyearnum.data = newHandlearray2
              this.budgetdata.data[1].money1 = updatedata.printingfee
              this.budgetdata.data[3].money1 = updatedata.postandtele
              this.budgetdata.ptdata[0].money1 = updatedata.equipment
              this.budgetdata.idupdate = updatedata.id
              this.budgetdata.data[0].money1 = updatedata.officeexpenses
              this.budgetdata.data[6].money1 = updatedata.trainingfee
              this.budgetdata.data[7].money1 = updatedata.laborfee
              this.budgetdata.data[8].money1 = updatedata.othergoodsandservices
              this.budgetdata.data[5].money1 = updatedata.conferencefee
              this.budgetdata.data[2].money1 = updatedata.consultationfee
              this.budgetdata.hjdata[0].money1 = updatedata.sum
              this.budgetdata.data[4].money1 = updatedata.travelexpenses
              this.copejfyslist = _.clone(this.budgetdata)
              this.copeallyearlist = _.clone(this.allyearnum.data)
            } else {
              this.budgetdata = {
                sel: null, // 选中行
                id: '',
                idupdate: '', // 驳回预算后得重新提交得id
                columns: [
                  { field: 'expense', title: '经费开支项目' },
                  { field: 'money', title: '金额（万元）' }
                ],
                data: [
                  {
                    id: '',
                    expense: '资料费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '数据采集者',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '会议费/差旅费/国际合作与交流费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '专家咨询费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '劳务费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '印刷出版费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '其他支出费',
                    money: '',
                    money1: ''
                  }
                ],
                ptdata: [
                  {
                    id: '',
                    money: '',
                    money1: ''
                  }
                ],
                hjdata: [
                  {
                    money: '',
                    money1: ''
                  }
                ]
              }
              let budgetdata = {
                sel: null, // 选中行
                id: '',
                idupdate: '', // 驳回预算后得重新提交得id
                columns: [
                  { field: 'expense', title: '经费开支项目' },
                  { field: 'money', title: '金额（万元）' }
                ],
                data: [
                  {
                    id: '',
                    expense: '资料费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '数据采集者',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '会议费/差旅费/国际合作与交流费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '专家咨询费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '劳务费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '印刷出版费',
                    money: '',
                    money1: ''
                  },
                  {
                    id: '',
                    expense: '其他支出费',
                    money: '',
                    money1: ''
                  }
                ],
                ptdata: [
                  {
                    id: '',
                    money: '',
                    money1: ''
                  }
                ],
                hjdata: [
                  {
                    money: '',
                    money1: ''
                  }
                ]
              }
              let allyearnum = {
                sel: null, // 选中行
                columns: [
                  { field: 'year', title: '年份', width: '750px' },
                  { field: 'money', title: '金额（万元）' }
                ],
                data: []
              }

              this.allyearnum = {
                sel: null, // 选中行
                // columns: [
                //   { field: "year", title: "年份" },
                //   { field: "money", title: "金额（万元）" },
                //   { field: "money", title: "学校金额（万元）" },
                // ],
                data: []
              }
              // this.iseditys && this.fziseditys驳回预算后的调整经费预算内容
              if (this.iseditys && this.fziseditys) {
                this.allyearnum.columns = [
                  { field: 'year', title: '年份', width: '750px' },
                  { field: 'money', title: '金额（万元）' },
                  {
                    field: 'money1',
                    title: '调整金额（万元）'
                  }
                ]
              } else {
                this.allyearnum.columns = [
                  { field: 'year', title: '年份', width: '750px' },
                  { field: 'money', title: '金额（万元）' }
                ]
              }
              this.copejfyslist = _.clone(budgetdata)
              this.copeallyearlist = _.clone(allyearnum.data)
            }
          }
        }
      }
    })
  }
  // 获取负责人表内容，预期研究成果,经费管理，单位意见，课题论证活页
  getprincipalinfo(interficename, datasource, type) {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid
    }
    interficename(userinfo).then((res) => {
      if (res.code === 200) {
        if (res.data != null) {
          res.data.forEach((item) => {
            if (item.isset == 0) {
              item.isset = false
            } else {
              item.isset = true
            }
          })
          this[datasource].data = res.data
          this.copepricdata = _.clone(res.data)
        } else {
          // 负责人数据源
          if (type == 0) {
            this.principal.data = []
            let data = []
            this.copepricdata = _.clone(data)
          } else {
            // 预期研究成果数据源
            this.expecteddata.data = []
            let data = []
            this.copepricdata = _.clone(data)
          }
        }
      }
    })
  }

  // 课题论证设计，研究基础及条件,经费管理，单位意见，课题论证活页
  getobjsinfo(interficename, datasource) {
    let userinfo = {
      page: 1,
      limit: 10,
      topicId: this.topicid
    }
    this.ktloading = true
    this.ktloadingtitle = '数据正在加载中，请等待...'
    interficename(userinfo).then((res) => {
      if (res.code === 200) {
        this.ktloading = false
        if (res.data != null) {
          this.editor[datasource] = res.data.content
          this.editor.id = res.data.id // 3.9修改
          this.editor.topicName = res.data.topicname
          this.copetopicname = _.clone(res.data.topicname)
          this.copeobj = res.data.content
        } else {
          if (datasource == 'dwyjcontent') {
            this.editor[datasource] =
              '  申请书所填写的内容属实；该课题负责人及参加者的政治和业务素质适合承担本课题的研究工作；本单位能提供完成本课题所需的时间和条件；本单位同意承担本项目的管理任务和信誉保证。'
          } else {
            this.editor[datasource] = ''
          }
          this.copeobj = ''
        }
      }
    })
  }
  getktlzsj() {
    let param: any = {
      id: this.topicid,
      fileType: 0
    }
    let paramjd = {
      id: this.topicid,
      fileType: 2
    }
    // fileType0 正常上传附件   1驳回预算后的附件   负值返回所有
    if (!this.iseditys) {
      getktsjinfo(param).then((res) => {
        this.uploadData = res.data.itemList
        this.ruleForm.fileid = res.data.id
        if (this.uploadData.length > 0) {
          this.subisuse = false
          this.subbtn = 'primary'
        }
      })
    } else {
      let paramys = {
        id: this.topicid,
        fileType: 1
      }
      getktsjinfo(param).then((res) => {
        this.uploadData = res.data.itemList
        if (this.uploadData.length > 0) {
          this.subisuse = false
          this.subbtn = 'primary'
        }
        this.ruleForm.fileid = res.data.id
      })
      getktsjinfo(paramys).then((res) => {
        this.ysuploadData = res.data.itemList
        if (this.ysuploadData.length > 0) {
          this.subysisuse = false
          this.subysbtn = 'primary'
        }
        this.ruleForm.fileid = res.data.id
      })
    }
    if(this.jieduan){
      getktsjinfo(paramjd).then((res) => {
        this.jduploadData = res.data.itemList
        if (this.jduploadData.length > 0) {
          this.subysisuse = false
          this.subysbtn = 'primary'
        }
        this.ruleForm.fileid = res.data.id
      })
    }
    if(this.jieti){
      paramjd.fileType = 3
      getktsjinfo(paramjd).then((res) => {
        this.jtuploadData = res.data.itemList
        if (this.jtuploadData.length > 0) {
          this.subysisuse = false
          this.subysbtn = 'primary'
        }
        this.ruleForm.fileid = res.data.id
      })
    }
  }
  // 获取相关证书info接口
  getciterinfo() {
    let userinfo = {
      id: this.topicid
    };
    (this.$refs.uploadzs as any).clearFiles()
    getcertificateinfo(userinfo).then((res) => {
      // this.uploadobj.fileSizeIsSatisfy = [];
      if (res.code === 200) {
        if (res.data.id == null) {
          this.uploadid = ''
        } else {
          this.uploadid = res.data.id
        }
        let newArray: any = []
        res.data.picList.forEach((item) => {
          item = this.baseurl + item
          newArray.push({ url: item })
        })
        this.uploadobj.fileSizeIsSatisfy = newArray
        this.$nextTick(() => {
          if (!this.iswatch) {
            $('.el-upload-list__item-delete').css({ display: 'none' })
          }
        })
        this.copefilelist = _.clone(this.uploadobj.fileSizeIsSatisfy)
      }
    })
  }

  handleDeletetopic(type, index, row) {
    this.$confirm('确定删除这条数据吗, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        if (type == 0) {
          this.uploadData.splice(index, 1)
          if (this.uploadData.length == 0) {
            this.subbtn = 'info'
            this.subisuse = true
          }
        } else if (type == 2) {
          this.jduploadData.splice(index, 1)
          this.subbtn = 'info'
          this.jdsubisuse = true
        } else if (type == 3) {
          this.jtuploadData.splice(index, 1)
          this.subbtn = 'info'
          this.jdsubisuse = true
        } else {
          this.ysuploadData.splice(index, 1)
          this.subbtn = 'info'
          this.subisuse = true
        }
        let start = row.loadPath.indexOf('=')
        let end = row.loadPath.indexOf('&')
        row.loadPath = row.loadPath.substring(start + 1, end)
        let param = {
          fileName: row.fileName,
          filePath: row.loadPath,
          fileSize: row.fileSize,
          id: row.id,
          isdelete: 1
        }
        updatetopicfile(param).then((res) => {
          if (res.code === 200) {
            this.$message.success('删除成功')

            if (this.ysuploadData.length == 0) {
              this.subysbtn = 'info'
              this.subysisuse = true
            }
          }
        })
      })
      .catch(() => {})
  }
  handleDeleteystopic() {}
  handleRemovetopic(file, fileList) {
    this.ruleForm.filelist = fileList
  }

  handlePreview(file) {}
  handleExceed(files, fileList) {
    console.log(files)
    this.$message.warning(
      `当前限制只允许上传 1 个文件`
    )
  }
  uploadtopic(type) {
    if (type == 0) {
      this.ruleForm.visible = true
    } else if (type == 2) {
      this.ruleForm.jdvisible = true
    } else if (type == 3) {
      this.ruleForm.jtvisible = true
    } else {
      this.ruleForm.bhvisible = true
    }
    this.ruleForm.filelist = []
  }
  topicfilechange(file, filelist) {
    const isMaxsize = file.size / 1024 / 1024 < 200
    if (!isMaxsize) {
      this.$message.warning('文件大小不能超过200M')
      this.ruleForm.filelist = []
    } else {
      this.ruleForm.filelist.push(file)
    }
  }
  handleWatch(row) {
    let index = row.loadPath.indexOf('=')
    let index_ = row.loadPath.indexOf('&')
    row.loadPath = row.loadPath.substring(index + 1, index_)
    let href = (window as any).downloadurl +'/pdf/' + row.loadPath

    const savea = document.createElement('a')
    savea.download = row.fileName
    savea.href = href
    savea.click()
  }
  uploadfile(type) {
    if (this.ruleForm.filelist.length == 0) {
      this.$message.warning('未选择文件，请选择后上传')
    } else {
      let ispdf = false
      let isPDF = false
      let isRar = false
      let isZip = false
      // 判断上传文件的类型
      this.ruleForm.filelist.forEach((res) => {
        if (res.name.substring(res.name.lastIndexOf('.') + 1) == 'pdf') {
          ispdf = true
        } else if (res.name.substring(res.name.lastIndexOf('.') + 1) == 'PDF') {
          isPDF = true
        } else if (res.name.substring(res.name.lastIndexOf('.') + 1) == 'rar') {
          isRar = true
        } else if (res.name.substring(res.name.lastIndexOf('.') + 1) == 'zip') {
          isZip = true
        }
      })
      if (ispdf || isPDF) {
        let formdata: any = new FormData()
        this.ruleForm.filelist.forEach((res) => {
          formdata.append('file', res.raw)
        })
        formdata.append('tableType', 1)
        formdata.append('topicId', this.topicid)
        formdata.append('state', 3)
        formdata.append('isdelete', 0)
        formdata.append('id', this.uploadid)
        if (type == 0) {
          formdata.append('fileType', 0)
        } else if(type == 1){
          formdata.append('fileType', 1)
        }
        this.uploadloading = true
        uploadzsxg(formdata).then((res) => {
          if (res.code == 200) {
            this.uploadloading = false
            this.$message.success('课题附件上传成功')
            this.subbtn = 'primary'
            this.subisuse = false
            this.ruleForm.visible = false
            this.ruleForm.bhvisible = false
            this.getktlzsj()
          } else if (res.code == 201) {
            this.$message.warning('服务器出了小差,请刷新页面重新上传')
          }
        })
      } else if (isRar || isZip) {
        if (type === 3) {
          let formdata: any = new FormData()
          this.ruleForm.filelist.forEach((res) => {
            formdata.append('file', res.raw)
          })
          formdata.append('tableType', 2)
          formdata.append('topicId', this.topicid)
          formdata.append('state', 3)
          formdata.append('isdelete', 0)
          formdata.append('id', this.uploadid)
          formdata.append('fileType', 3)
          this.uploadloading = true
          uploadzsxg(formdata).then((res) => {
            if (res.code == 200) {
              this.uploadloading = false
              this.$message.success('结题汇报附件上传成功')
              this.subbtn = 'primary'
              this.subisuse = false
              this.ruleForm.jtvisible = false
              this.getktlzsj()
            } else if (res.code == 201) {
              this.$message.warning('服务器出了小差,请刷新页面重新上传')
            }
          })
        } else {
          let formdata: any = new FormData()
          this.ruleForm.filelist.forEach((res) => {
            formdata.append('file', res.raw)
          })
          formdata.append('tableType', 2)
          formdata.append('topicId', this.topicid)
          formdata.append('state', 3)
          formdata.append('isdelete', 0)
          formdata.append('id', this.uploadid)
          if (type == 2) {
            formdata.append('fileType', 2)
          }
          this.uploadloading = true
          uploadzsxg(formdata).then((res) => {
            if (res.code == 200) {
              this.uploadloading = false
              this.$message.success('阶段汇报附件上传成功')
              this.subbtn = 'primary'
              this.subisuse = false
              this.ruleForm.jdvisible = false
              this.getktlzsj()
            } else if (res.code == 201) {
              this.$message.warning('服务器出了小差,请刷新页面重新上传')
            }
          })
        }

      }
      else {
        this.$message.warning('只允许上传pdf、zip、rar文件，请检查后重新上传')
      }
    }
  }
}
